import { createRequestTypes } from '../utils';

export const SUBMIT = createRequestTypes('orderItemProduct/SUBMIT');

